import type {FC} from 'react';
import type {IFoodInfo} from '../types';
import {useNavigate} from 'react-router';
import {Row} from '../types/FoodInfoPage.style.ts';
import useFoodStore from '../../../store/useFoodStore.ts';
import {formatCoordinate} from '../../../utils/DateUtil.ts';
import {getCurrentFocusKey, setFocus, useFocusable} from '@noriginmedia/norigin-spatial-navigation';

interface IFoodInfoRowProps {
    index: number;
    foodInfo: IFoodInfo;
}

const FoodInfoRow: FC<IFoodInfoRowProps> = ({index, foodInfo}) => {
    const navigate = useNavigate();
    const {setFoodInfo} = useFoodStore();

    const goTo = (id: IFoodInfo) => {
        const formattedInfo = {
            ...id,
            mapx: formatCoordinate(id.mapx, 3),
            mapy: formatCoordinate(id.mapy, 2),
        };
        setFoodInfo(formattedInfo);
        const safe = btoa(encodeURIComponent(id.title));
        navigate(`/foodInfo/${safe}`);
    };

    const {ref, focused, focusKey} = useFocusable({
        focusKey: `food-info-${index + 1}`,
        onEnterPress: () => goTo(foodInfo),
        onArrowPress: (direction) => {
            if (direction === 'up' && getCurrentFocusKey() === 'food-info-1') {
                setFocus('food-info-back-button');
                return false;
            } else {
                return true;
            }
        },
    });

    return (
        <Row ref={ref} $focused={focused} onClick={() => goTo(foodInfo)}>
            <td dangerouslySetInnerHTML={{__html: foodInfo.title}} />
            <td>{foodInfo.category}</td>
            <td>{foodInfo.address}</td>
        </Row>
    );
};

export default FoodInfoRow;
